export default __webpack_public_path__ + "static/media/car-right.9ae0e033.svg";